'use client';
import styled from 'styled-components';

export const Trigger = styled.div.attrs({
  tabIndex: 0,
})`
  width: 16px;
  height: 16px;
`;
